import {
  ErrorText,
  FieldContainer,
  FormContainer,
  Label,
  StyledButtonGroup,
} from "../styled";
import Input from "@8x8/oxygen-input";
import { ADDRESS_MODAL_ACTIONS, COUNTRY_CODES } from "../constants";
import Select from "@8x8/oxygen-select";
import React, { useEffect, useState } from "react";
import {
  useLazySearchAddressQuery,
  useLazyGetAddressByIdQuery,
  useCreateAddressMutation,
} from "@/react/services/common/addressApi";
import { Button } from "@/react/styled";
import { OverlaySpinner } from "@/react/components/OverlaySpinner";
import { LoadingSpinner } from "@/react/components/customer/modal/results/styled";
import {
  useValidateAddressMutation,
  useValidateFreeformAddressMutation,
} from "./addressValidationApi";
import { addressValidation } from "./addressValidation";

export const FreeformAddressSelector = ({
  selectedAddress,
  action,
  onSave,
}) => {
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [freeformAddress, setFreeformAddress] = useState("");
  const [validAddress, setValidAddress] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");

  const [validateFreeform, { isLoading: isLoadingFreeformValidation }] =
    useValidateFreeformAddressMutation();
  const [validateAddress, { isLoading: isLoadingValidation }] =
    useValidateAddressMutation();
  const [searchAddress, { isLoading: isSearchingAddress }] =
    useLazySearchAddressQuery();
  const [findAddress, { isLoading: isFetchingAddress }] =
    useLazyGetAddressByIdQuery();
  const [createAddress, { isLoading: isCreatingAddress }] =
    useCreateAddressMutation();

  useEffect(() => {
    if (action === ADDRESS_MODAL_ACTIONS.EDIT) {
      findAddress({ addressId: selectedAddress.id })
        .then((response) => {
          if (response.isSuccess) {
            setValidAddress(response.data);
            setFreeformAddress(response.data?.displayForm);
            setSelectedCountry(
              COUNTRY_CODES.find(
                (countryCode) => response.data?.country === countryCode.value
              )
            );
          } else {
            console.debug(response);
            throw new Error("Address not found");
          }
        })
        .catch((error) => setErrorMessage(JSON.stringify(error)));
    }
  }, [action, selectedAddress]);

  const handleValidate = () => {
    addressValidation({
      freeformAddress,
      selectedCountry,
      validateFreeform,
      validateAddress,
      searchAddress,
      createAddress,
      setErrorMessage,
      setFreeformAddress,
      setValidAddress,
    });
  };

  const handleReset = () => {
    setSelectedCountry(null);
    setFreeformAddress("");
    setValidAddress(null);
    setErrorMessage("");
  };

  const isLoading =
    isLoadingFreeformValidation ||
    isLoadingValidation ||
    isSearchingAddress ||
    isCreatingAddress ||
    isFetchingAddress;

  return (
    <FormContainer>
      {isLoading && <OverlaySpinner />}
      <FieldContainer>
        <Label>Country</Label>
        <Select
          value={selectedCountry}
          options={COUNTRY_CODES}
          onChange={(opt) => setSelectedCountry(opt)}
          isClearable={true}
          theme={{
            menuZindex: 3000,
          }}
          menuPortalTarget={document.body}
        />
      </FieldContainer>
      <FieldContainer>
        <Label>Freeform Address</Label>
        <Input
          value={freeformAddress}
          onChange={(e) => setFreeformAddress(e.target.value)}
        />
      </FieldContainer>
      {validAddress && !errorMessage && (
        <FieldContainer>
          <Label>Verified address found:</Label>
          <div>{validAddress.displayForm}</div>
        </FieldContainer>
      )}
      {errorMessage && <ErrorText>{errorMessage}</ErrorText>}
      <StyledButtonGroup>
        {validAddress ? (
          <Button
            variant={"primary"}
            onClick={() => onSave(validAddress)}
            disabled={isSearchingAddress}
          >
            Save
            {isSearchingAddress && <LoadingSpinner />}
          </Button>
        ) : (
          <Button variant={"primary"} onClick={handleValidate}>
            Validate
          </Button>
        )}
        <Button variant={"secondary"} onClick={handleReset}>
          Clear
        </Button>
      </StyledButtonGroup>
    </FormContainer>
  );
};
